<!-- src/views/qianming.vue -->
<template>
  <div class="signature-modal">
    <!-- 横屏提示 -->
    <!-- <div class="rotation-hint" v-if="isPortrait">
      <van-icon name="rotate-right" size="48" color="#1989fa" />
      <p>请将手机横屏以获得更好的签名体验</p>
    </div> -->

    <!-- 签名内容区域：包含按钮和画布 -->
    <div class="signature-content">
      <!-- 【已移动】按钮区域现在在画布上方 -->
      <div class="modal-actions">
        <van-button type="default" @click="clearSignature">清除</van-button>
        <van-button type="primary" @click="saveSignature">保存</van-button>
      </div>

      <!-- 画布区域 -->
      <div class="signature-container">
        <div class="signature-pad-wrapper" :class="{ 'portrait-mode': isPortrait }">
          <canvas ref="signaturePad" id="signatureCanvas"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';
import { Icon } from 'vant';
import { ElMessage } from 'element-plus'; // 直接导入


export default {
  name: 'Qianming',
  components: {
    VanIcon: Icon,
  },
  data() {
    return {
      signaturePad: null,
      isPortrait: true, // 是否为竖屏
      resizeTimeout: null,
    };
  },
  mounted() {
    this.checkOrientation();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => {
      this.initSignaturePad();
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    checkOrientation() {
      this.isPortrait = (window.orientation === 0 || window.orientation === 180);
    },
    handleOrientationChange() {
      this.checkOrientation();
      this.resizeCanvas();
    },
    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.checkOrientation();
        this.resizeCanvas();
      }, 200);
    },
    initSignaturePad() {
      const canvas = this.$refs.signaturePad;
      if (!canvas) {
        console.error('未找到 Canvas 元素');
        return;
      }

      this.resizeCanvas();

      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      this.signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        penColor: 'rgb(0, 0, 0)',
        thickness: 3,
        onBegin: () => { },
      });
    },
    resizeCanvas() {
      const canvas = this.$refs.signaturePad;
      if (!canvas) return;

      const container = this.$refs.signaturePad.parentElement;
      if (!container) return;

      const imageData = this.signaturePad ? this.signaturePad.toDataURL() : null;

      canvas.style.width = '100%';
      canvas.style.height = '100%';

      const dpr = window.devicePixelRatio || 1;
      const rect = container.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;

      const ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);

      if (imageData && this.signaturePad) {
        setTimeout(() => {
          this.signaturePad.fromDataURL(imageData);
        }, 0);
      }
    },
    saveSignature() {
      if (!this.signaturePad) {
        ElMessage.error('签名组件初始化失败');
        return;
      }
      if (this.signaturePad.isEmpty()) {
        ElMessage.error('请先签名再保存');
        return;
      }
      try {
        const signatureImage = this.signaturePad.toDataURL('image/png');
        sessionStorage.setItem('signatureImage', signatureImage);
        ElMessage.success('签名保存成功');
        setTimeout(() => {
          this.$router.go(-1);
        }, 500);
      } catch (error) {
        console.error('保存签名时出错:', error);
        ElMessage.error('签名保存失败，请重试');
      }
    },
    clearSignature() {
      if (this.signaturePad) {
        this.signaturePad.clear();
      }
    },
  },
};
</script>

<style scoped>
/* 签名弹窗整体样式 */
.signature-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;
}

/* 横屏提示 */
.rotation-hint {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.rotation-hint p {
  margin-top: 10px;
  color: #666;
}

/* 【新增】签名内容的父容器，使用 Flex 布局 */
.signature-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  /* 占据所有可用空间 */
  justify-content: center;
  /* 垂直居中 */
}

/* 【已修改】按钮区域的样式 */
.modal-actions {
  display: flex;
  justify-content: center;
  /* 水平居中按钮 */
  gap: 15px;
  /* 按钮之间的间距 */
  margin-bottom: 15px;
  /* 按钮下方与画布的间距 */
  padding: 0 20px;
  /* 左右留出一些边距 */
  z-index: 10;
}

.modal-actions van-button {
  width: 120px;
  /* 给按钮一个固定宽度，使其更美观 */
}

/* 签名容器 */
.signature-container {
  flex: 1;
  /* 让画布容器占据剩余的垂直空间 */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* 签名画布外层包装器 */
.signature-pad-wrapper {
  width: 100%;
  height: 100%;
  max-height: 70vh;
  /* 限制最大高度 */
  border: 1px solid #eee;
  border-radius: 8px;
  background-color: #f9f9f9;
  overflow: hidden;
}

.signature-pad-wrapper.portrait-mode {
  max-width: 80%;
  max-height: 50%;
}

#signatureCanvas {
  width: 100%;
  height: 100%;
  touch-action: none;
  user-select: none;
}
</style>